export default {
	methods: {
		fetchFeed(fromVersion = 0) {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.getJSON("EquipmentGeoData/request",{
					method: "GetFeed",
					params: {
						typeName: 'DeviceStatusInfo',
						fromVersion
					}
				}).then(response => {
					resolve(response)
				})
			})
		}
	}
}